import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CUSTOMER_TOKEN } from "../constants/constants";
import { savePostAuthRedirect } from "../utils/auth_redirect";

/**
 * Lets guests use public screens and defers login until an account-only action
 * is requested. The requested destination is restored after authentication.
 */
export function useRequireAuth() {
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthenticated = Boolean(localStorage.getItem(CUSTOMER_TOKEN));

  const requireAuth = useCallback(
    (redirectTo = `${location.pathname}${location.search}`) => {
      if (localStorage.getItem(CUSTOMER_TOKEN)) {
        return true;
      }

      savePostAuthRedirect(redirectTo);
      navigate("/login");
      return false;
    },
    [location.pathname, location.search, navigate]
  );

  return { isAuthenticated, requireAuth };
}
